import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Hyperlink from '../common/Hyperlink';
import { type } from '../../styles/typography';

const TONES = {
  black: css`
    background-color: var(--b-black);
    color: var(--b-white);
    &:hover {
      background-color: var(--b-graphite);
    }
  `,
  white: css`
    background-color: var(--b-white);
    color: var(--b-black);
    &:hover {
      background-color: var(--b-fog);
    }
  `,
  translucent: css`
    background-color: rgba(255, 255, 255, 0.13);
    color: rgba(255, 255, 255, 0.79);
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
  `,
  silver: css`
    background-color: var(--b-silver);
    color: var(--b-black);
    &:hover {
      background-color: var(--b-lavender-grey);
    }
  `,
};

const SIZES = {
  small: css`
    ${type('label', 'small')};
    height: 36px;
    padding: 0 18px;
  `,
  medium: css`
    ${type('label', 'medium')};
    height: 44px;
    padding: 0 22px;
  `,
  large: css`
    ${type('label', 'large')};
    height: 60px;
    padding: 0 31px;
  `,
};

// eslint-disable-next-line no-unused-vars
const Base = styled(({ tone, size, pill, fullWidth, ...rest }) => <Hyperlink {...rest} />)`
  ${({ size }) => SIZES[size] || SIZES.medium};
  ${({ tone }) => TONES[tone] || TONES.black};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  border-radius: ${({ pill }) => (pill ? '100px' : 'var(--b-radius-s)')};
  white-space: nowrap;
  text-decoration: none !important;
  transition:
    background-color 0.16s ease,
    transform 0.16s ease;
  cursor: pointer;
  text-wrap: wrap;
  text-align: center;

  &:active {
    transform: scale(0.98);
  }
`;

const track = trackingData => () => {
  if (typeof window !== 'undefined' && window.analytics && trackingData) {
    analytics.track('Clicked CTA Button', trackingData);
  }
};

const BrandButton = ({ to, trackingData, onClick, children, ...props }) => {
  const handleClick = e => {
    track(trackingData)();
    if (onClick) onClick(e);
  };

  return (
    <Base to={to} onClick={handleClick} {...props}>
      {children}
    </Base>
  );
};

BrandButton.propTypes = {
  to: PropTypes.string.isRequired,
  trackingData: PropTypes.object,
  onClick: PropTypes.func,
  children: PropTypes.node,
  tone: PropTypes.oneOf(['black', 'white', 'translucent', 'silver']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  pill: PropTypes.bool,
  fullWidth: PropTypes.bool,
  openInNewTab: PropTypes.bool,
  className: PropTypes.string,
};

export default BrandButton;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/brand/BrandButton.js